<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show
                :id="id"
                :models="models"
                :infos="infos"
                topClass=""
            ></show>

            <v-col class="pa-0">
                <v-card :elevation="1" class="background-2 round-card">
                    <v-card-title class="pa-3">
                        <p class="pl-2 pl-xl-3">Modifica dettaglio</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-container class="pa-2" fluid>
                        <fields-generator 
                            class="mt-4"
                            :fieldsset.sync="fieldsset"
                            :model="troubleEdited"
                            ref="fieldsgenerator"
                            :selectChange="onChange"
                        ></fields-generator>
                        <small class="pl-4">* Indica i campi obbligatori</small>
                    </v-container>
                </v-card>
            </v-col>

            <v-col class="pa-0 pt-4" v-if="relations.interventions && relations.interventions.collection">
                <trouble-interventions
                    :collection="relations.interventions.collection"
                    :headers="relations.interventions.info.fieldDefs"
                    :totals="troubleEdited.totals.interventions"
                ></trouble-interventions>
            </v-col>

            <v-col class="pa-0 pt-4" v-if="$store.getters.checkSettings('products_association_intervention') && relations.interventionproducts && relations.interventionproducts.collection">
                <trouble-products
                    :collection="relations.interventionproducts.collection"
                    :headers="relations.interventionproducts.info.fieldDefs"
                    :totals="troubleEdited.totals.products"
                    title="Prodotti utilizzati"
                ></trouble-products> 
            </v-col>

            <v-col class="pa-0 pt-4">
                <trouble-totals
                    :total="troubleEdited.total"
                    :subtotal="troubleEdited.subtotal"
                    :tax="troubleEdited.tax"
                    :totals-fields-config="troubleTotalsFields"
                    :totals-hidden="troubleTotalsHidden"
                ></trouble-totals>
            </v-col>


            <v-col class="pa-0 pt-4">
                <signature-dialog
                    ref="signatureDialog"
                    :button="button"
                    :url="'troubles/' + id"
                    full-model
                    model-def="troubles"
                    :model="troubleEdited"
                ></signature-dialog>
            </v-col>
        </v-col>
    </v-row>
</template>

<script>

    import Vue from 'vue'
    import FormsMixin from '@/mixins/FormsMixin'
	import SignatureDialog from '@/components/common/SignatureDialog'
    import TroubleTotals from '@/components/modules/tickets/TroubleTotals'
    import TroubleProducts from '@/components/modules/tickets/TroubleProducts'
    import TroubleInterventions from '@/components/modules/tickets/TroubleInterventions'

    export default {
        name: 'trouble-close',
        mixins: [FormsMixin],
        components: {
            TroubleTotals,
            SignatureDialog,
            TroubleProducts,
            TroubleInterventions,
        },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
                saved: false,
                relations: {},
                fieldsset: {},
                dialog: false,
                loading: false,
                troubleEdited: {},
                showCloseDialog: false,
                modelDef: 'troubles-info-close',
                button: {
                    params: {
                        tooltip: 'Chiudi ticket',
                        icon: 'block',
                        fab: true,
                        fixed: true,
                        right: true,
                        bottom: true,
                        button_color: 'red',
                        dark: true
                    }
                }, 
            }
        },

        watch: {
            'troubleEdited.asset_id'() {
                this.getTotals()
            },
            'troubleEdited.contract_id'() {
                this.getTotals()
            },
            'troubleEdited.warranty'() {
                this.getTotals()
            },
            'troubleEdited.hourly_rate'() {
                this.getTotals()
            },
            'troubleEdited.hourly_rate_id'(value) {
                if(value != 0) {
                    this.getTotals()
                }
            },
            'troubleEdited.fixed_visit_cost'() {
                this.getTotals()
            },
            'troubleEdited.fixed_visit_cost_id'(value) {
                if(value != 0) {
                    this.getTotals()
                }
            },
            'troubleEdited.extra_visit'(value) {
                this.getTotals()
            },
            'troubleEdited.fixed_total'(value) {
                this.getTotals()
            },
            'troubleEdited.gross'(value) {
                this.getTotals()
            },
        },

        created() {
            this.initialize()
        },

        mounted() {
            this.$eventBusUtility.$on('savedSignatureTrouble', () => {
                this.$router.push({ name: 'troubles-show', params: { id: parseInt(this.id) }})
            })
            this.$eventBusUtility.$on('updateTroubleShow', () => {
                this.initialize()
            })
            
            this.$eventBusUtility.$on('validateTroubleShow', () => {
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return this.handleValidationErrorAdvanced()
                    }
			        this.$eventBusUtility.$emit('validTroubleShow')

                }).catch(() => {

                })
            })
        },

        methods: {

            initialize() {
                this.axios.get(this.modelDef + '/' + this.id).then(response => {
                    this.models = response.data.models
                    this.infos = response.data.infos
                    this.infos.trouble.buttonShowDefs = response.data.infos.trouble.buttonShowDefs.splice(0, 2)
                    this.relations = response.data.relations
                    this.fieldsset = this.models.trouble_close
                    
                    this.troubleEdited = response.data.trouble
                    // this.troubleEdited = _.pick(response.data.models.trouble, ['company_id', 'asset_id', 'destination_id', 'contract_id', 'subscription_id', 'payment_term', 'fixed_total', 'gross', 'extra_visit', 'warranty', 'promo'])
                    this.troubleEdited['status'] = 'closed'

                    // _.forEach(response.data.models.trouble, (value, k) => {
                    //     if(_.startsWith(k, 'customfield_')) {
                    //         _.merge(this.troubleEdited, _.pick(response.data.models.trouble, [k]))
                    //     }
                    // })
                    this.setTotals(this.models.trouble.totals)
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })
            },

            onChange(field, event) {
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.troubleEdited, this.support)).then((responses) => {
                    responses.forEach(response => {
                        if(this.troubleEdited[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.troubleEdited[response.key])
                        }
                    })
                })
            },
            
            getTotals() {
                if(this.totalsTimeout)
                    clearTimeout(this.totalsTimeout)
                
                this.totalsTimeout = setTimeout(() => {

                    let data = {
                        'asset_id': this.troubleEdited.asset_id ? this.troubleEdited.asset_id : null,
                        'contract_id': this.troubleEdited.contract_id ? this.troubleEdited.contract_id : null,
                        'warranty': this.troubleEdited.warranty ? 1 : 0,
                        'force_params': true,
                        'hourly_rate': this.troubleEdited.hourly_rate_id == 0 ? this.troubleEdited.hourly_rate : null,
                        'hourly_rate_id': this.troubleEdited.hourly_rate_id != 0 ? this.troubleEdited.hourly_rate_id : null,
                        'fixed_visit_cost':this.troubleEdited.fixed_visit_cost_id == 0 ? this.troubleEdited.fixed_visit_cost : null,
                        'fixed_visit_cost_id': this.troubleEdited.fixed_visit_cost_id != 0 ? this.troubleEdited.fixed_visit_cost_id : null,
                        'extra_visit': this.troubleEdited.extra_visit ? 1 : 0,
                        'gross': this.troubleEdited.gross ? 1 : 0,
                        'fixed_total': this.troubleEdited.fixed_total == '' ? null : this.troubleEdited.fixed_total,
                    }

                    this.axios.post('troubles-totals/' + this.id, data).then(response => {
                        // Set select options in child select
                        this.setTotals(response.data.totals)

                    }, response => {

                    })
                }, 300)
            },
    
            setTotals(totals) {
                this.$set(this.troubleEdited, 'totals', totals)
                this.$set(this.troubleEdited, 'total', (totals.interventions.total + totals.products.total))
                this.$set(this.troubleEdited, 'subtotal', (totals.interventions.subtotal + totals.products.subtotal))
                this.$set(this.troubleEdited, 'tax', (totals.interventions.tax + totals.products.tax))
            },

    
            selectChange(field, event) {
                if(event != null) {
                    this.axios.get('assets/' + event + '/contracts').then(response => {
                        // Set select options in child select
                        Vue.set(this.items, 'contracts', response.data)

                    }, response => {

                    })
                } else {
                    Vue.set(this.items, 'contracts', [])
                    Vue.set(this.troubleEdited, 'contract_id', null)
                }
            },
        },

        computed: {
            troubleTotalsFields() {
                if (this.infos?.trouble?.totals_config?.fields) {
                    return this.infos.trouble.totals_config.fields
                }
                return null
            },

            troubleTotalsHidden() {
                return this.infos?.trouble?.totals_config?.hidden || false
            }
        },

        beforeDestroy() {
			this.$eventBusUtility.$off('updateTroubleShow')
			this.$eventBusUtility.$off('savedSignatureTrouble')
			this.$eventBusUtility.$off('validateTroubleShow')
		},
    }
</script>
